import { render, staticRenderFns } from "./personSurcharge.vue?vue&type=template&id=590b0d17&"
import script from "./personSurcharge.vue?vue&type=script&lang=js&"
export * from "./personSurcharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590b0d17')) {
      api.createRecord('590b0d17', component.options)
    } else {
      api.reload('590b0d17', component.options)
    }
    module.hot.accept("./personSurcharge.vue?vue&type=template&id=590b0d17&", function () {
      api.rerender('590b0d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-49pmXpk2rXZLV/JS/personSurcharge.vue"
export default component.exports